import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  getOrganizationProfileFallbackPath,
  useOrganizationProfileAccess,
} from '../../../hooks/useOrganizationProfileAccess';

const OrganizationProfileAccessGate = ({ children }) => {
  const { isResolved, canViewOrganizationProfile, canManageOrganizationProfile } = useOrganizationProfileAccess();

  if (!isResolved) {
    return children;
  }

  if (!canManageOrganizationProfile) {
    return <Redirect to={getOrganizationProfileFallbackPath(canViewOrganizationProfile)} />;
  }

  return children;
};

export default OrganizationProfileAccessGate;
